<app-navbar></app-navbar>

<div #smoothWrapper class="fixed top-0 left-0 w-full h-screen overflow-hidden">
  <div #smoothContent class="will-change-transform">
<section #heroSection class="w-full flex flex-col items-center gap-7 pt-24 md:pt-36 px-4 md:px-0 bg-neutral-50">
    <h1 #heroTitle class="font-normal! text-center opacity-0 translate-y-10 text-2xl md:text-4xl">Resultados tangibles <br> reduciendo riesgos</h1>
    <p #heroParagraph class="text-text-secondary opacity-0 translate-y-10 text-center px-4 md:px-0">Construya un historial de éxito y mejore sus indicadores</p>
    <button #heroButton pButton class="button-primary opacity-0">Contáctenos</button>

    <img #heroImage src="/assets/images/features/feature.svg" alt="feature" class="w-full md:w-[80%] mx-auto mt-5 opacity-0 scale-95">
</section>

<section #benefitsSection class="py-12 md:py-24 flex flex-col md:grid md:grid-cols-24 px-4 md:px-0 gap-8 md:gap-0">
    <div #stickySidebar class="md:col-start-2 md:col-span-4">
        <h5 #benefitsTitle class="text-primary! font-normal! md:sticky md:top-28">Beneficios</h5>
        <div class="h-6 md:h-12 w-full block"></div>
        <ul #benefitsList class="flex flex-row md:flex-col gap-4 md:sticky md:top-44 overflow-x-auto md:overflow-x-visible pb-2 md:pb-0">
            <li class="text-sm! text-text-secondary! whitespace-nowrap md:whitespace-normal">Usuarios</li>
            <li class="text-sm! text-text-secondary! whitespace-nowrap md:whitespace-normal">Indicadores</li>
            <li class="text-sm! text-text-secondary! whitespace-nowrap md:whitespace-normal">Fórmulas médicas</li>
        </ul>
    </div>
    <div class="md:col-start-6 md:col-end-24 md:col-span-full flex flex-col gap-0">
        <h1 #indicatorsTitle class="font-normal! opacity-0 translate-y-10 text-2xl md:text-4xl">Gestione sus indicadores con una sola interfaz</h1>
        <div class="block w-full h-6 md:h-12"></div>
        <div class="relative flex flex-col w-full gap-8">
            <div #card1 class="md:sticky p-6 md:p-10 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-8 md:gap-16 opacity-0 translate-y-10 mb-8" style="transform: translateY(0);">
                <div class="flex flex-col justify-between gap-6">
                    <h3 class="font-normal!">Usuarios</h3>
                    <div class="border-l-4 border-primary-200 pl-5 ">
                        Centralice la gestión de pacientes y médicos en una plataforma unificada que simplifica la administración, mejora la trazabilidad de la información y fortalece la toma de decisiones.
                    </div>
                </div>

                <div class="w-full flex justify-end aspect-square overflow-hidden isolate rounded-lg bg-gray-200 md:max-w-[500px]">
                    <img src="/assets/images/features/users.svg" alt="users" class="w-full h-full object-cover">
                </div>
            </div>

            <div #card2 class="md:sticky p-6 md:p-10 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-8 md:gap-16 opacity-0 translate-y-10 mb-8" style="transform: translateY(2rem);">
                <div class="flex flex-col justify-between gap-6">
                    <h3 class="font-normal!">Indicadores</h3>
                    <div class="border-l-4 border-primary-200 pl-5 ">
                        Obtenga una visión general de sus indicadores para monitorear avances, cumplimiento y alertas generadas.
                    </div>
                </div>

                <div class="w-full flex justify-end aspect-square overflow-hidden isolate rounded-lg bg-gray-200 md:max-w-[500px]">
                    <img src="/assets/images/features/indicators.svg" alt="indicators" class="w-full h-full object-cover">
                </div>
            </div>

            <div #card3 class="md:sticky p-6 md:p-10 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-8 md:gap-16 opacity-0 translate-y-10" style="transform: translateY(4rem);">
                <div class="flex flex-col justify-between gap-6">
                    <h3 class="font-normal!">Fórmulas médicas</h3>
                    <div class="border-l-4 border-primary-200 pl-5 ">
                        Gestione de manera eficiente las fórmulas médicas de sus pacientes, garantizando orden, acceso oportuno y seguimiento adecuado de los tratamientos.
                    </div>
                </div>

                <div class="w-full flex justify-end aspect-square overflow-hidden isolate rounded-lg bg-gray-200 md:max-w-[500px]">
                    <img src="/assets/images/features/prescriptions.svg" alt="prescriptions" class="w-full h-full object-cover">
                </div>
            </div>
        </div>
    </div>
</section>

<section #whySection class="py-12 md:py-24 flex flex-col md:grid md:grid-cols-24 bg-gray-50 mb-12 md:mb-24 px-4 md:px-0 gap-8 md:gap-0">
    <div class="md:col-start-2 md:col-span-4">
        <h5 #whyTitle class="text-primary! font-normal! md:top-28 md:sticky">¿Por qué nosotros?</h5>
        <div class="h-6 md:h-12 w-full block"></div>
    </div>
    <div class="md:col-start-6 md:col-end-24 flex flex-col gap-8">
        <div #whyContent class="opacity-0 translate-y-10">
            <h1 class="font-normal! mb-6 text-2xl md:text-4xl">Brinadamos una solución 360 grados</h1>
            <p class="text-text-secondary max-w-2xl">
                Nuestra plataforma está diseñada para proveer nuestro servicio a los pacientes mediante una apliación móvil y a los programas de pacientes mediante una interfaz web.
            </p>
        </div>
        
        <div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl">
                <div class="flex items-start gap-3">
                    <ng-icon name="phosphorCheck" class="text-primary! shrink-0 mt-1"></ng-icon>
                    <span class="text-text-secondary">Reduzca la asimetría de la información</span>
                </div>
                <div class="flex items-start gap-3">
                    <ng-icon name="phosphorCheck" class="text-primary! shrink-0 mt-1"></ng-icon>
                    <span class="text-text-secondary">Generación de alertas y tareas en tiempo real</span>
                </div>
                <div class="flex items-start gap-3">
                    <ng-icon name="phosphorCheck" class="text-primary! shrink-0 mt-1"></ng-icon>
                    <span class="text-text-secondary">Disponibilización de datos para un correcto seguimiento</span>
                </div>
                <div class="flex items-start gap-3">
                    <ng-icon name="phosphorCheck" class="text-primary! shrink-0 mt-1"></ng-icon>
                    <span class="text-text-secondary">Mayor control sobre situaciones particulares</span>
                </div>
                <div class="flex items-start gap-3">
                    <ng-icon name="phosphorCheck" class="text-primary! shrink-0 mt-1"></ng-icon>
                    <span class="text-text-secondary">Gestión de información en una única interfaz</span>
                </div>
                <div class="flex items-start gap-3">
                    <ng-icon name="phosphorCheck" class="text-primary! shrink-0 mt-1"></ng-icon>
                    <span class="text-text-secondary">Mejora en los niveles de adherencia de los pacientes</span>
                </div>
            </div>
        </div>

        <button pButton class="button-primary w-full md:w-auto" (click)="quote()">Obtener una cotización →</button>
    </div>
</section>
<app-footer></app-footer>
  </div>
</div>

